<template>
  <li class="chat-msg-item chat-msg-send" v-if="message.type==='send'">
    <div class="chat-time">{{message.formatted}}</div>
    <div>
      <div class="chat-msg-text">{{message.text}}</div>
    </div>
  </li>
  <li class="chat-msg-item chat-msg-accept" v-else-if="message.type==='accept'">
    <div v-if="role==='company'" class="chat-time">
      {{message.name}} {{message.formatted}}
    </div>
    <div v-else class="chat-time">{{message.formatted}}</div>
    <div>
      <div class="chat-msg-text">{{message.text}}</div>
    </div>
  </li>
  <li class="chat-msg-error" v-else-if="message.type==='error'">
    <div>{{message.text}}</div>
  </li>
  <li class="chat-msg-tip" v-else-if="message.type==='tip'">
    <div>{{message.text}}</div>
  </li>
</template>

<script>
export default {
  name: 'ChatMessageItem',
  props: {
    message: Object,
    role: {
      type: String,
      default: 'company',
    },
  },
};
</script>

<style scoped lang="scss">
.chat-msg-text {
  display: inline-block;
  padding: 5px 8px;
  //border: 1px solid #999;
  box-sizing: border-box;
  background: #fff;
}

.chat-msg-item {
  padding: 5px 8px;
  box-sizing: border-box;
}

.chat-time {
  font-size: 12px;
}

.chat-msg-send {
  text-align: right;

  & .chat-msg-text {
    background: #3EB2D9;
    border-color: #3EB2D9;
    color: #FFF;
  }
}

.chat-msg-error {
  text-align: center;

  & > div {
    padding: 0 15px;
    display: inline-block;
    line-height: 20px;
    border-radius: 3px;
    background: rgba(154, 21, 26, .15);
    color: #9A151A;
    font-size: 12px;
  }
}

.chat-msg-accept {
  color: #333;
}

.chat-msg-tip {
  text-align: center;
}
</style>